// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  apiKey: "AIzaSyA4y2BriJNrQ7pKUB1qv-9dv4HkRaELKf8",
  authDomain: "spaceapp-7b4c9.firebaseapp.com",
  databaseURL: "https://spaceapp-7b4c9.firebaseio.com",
  projectId: "spaceapp-7b4c9",
  storageBucket: "spaceapp-7b4c9.appspot.com",
  messagingSenderId: "505346269053",
  appId: "1:505346269053:web:9bd60366ccd17a74313614",
  measurementId: "G-FPHB4N1ZXK",
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
